<div class="data-load-error" [ngClass]="[type]">
  <svg-icon src="assets/icons/warning.svg"></svg-icon>
  <div class="data-load-error--text" [innerHTML]="translationKey | translate"></div>
</div>
